module.exports = __webpack_public_path__ + "img/mask.4af50f2a.svg";